module.exports = __webpack_public_path__ + "assets/pdf/SAGAE_Guide_utilisateur.8d0dd816.pdf";